import { format } from "date-fns";
import type { DateFormat } from "web_myplann/Shared/Utils/dateFormats";
import { type ZodType, z } from "zod";

export const optionalDateAsString = (
	dateFormat: (typeof DateFormat)[keyof typeof DateFormat],
	notInFutureMessage?: string,
): ZodType<string | null, z.ZodTypeDef, Date | null> =>
	z
		.date()
		.nullable()
		.refine(
			(val) =>
				!notInFutureMessage || val == null || val.getTime() <= Date.now(),
			notInFutureMessage,
		)
		.transform((val) => (val ? format(val, dateFormat) : null));
